import React, {useContext, useState} from 'react';
import { observer } from 'mobx-react-lite';
import {useHistory, useLocation} from 'react-router-dom';
import {PROFILE_ROUTE, FAVOURITES_ROUTE, CHAT_ROUTE} from '../../../utils/consts';
import { Context } from "../../../index";
import RegistrationForm from '../../modals/UserForms/RegistrationForm/RegistrationForm';
import ModalPortal from "../../../utils/ModalPortal";
import { reachGoal } from "../../../utils/metrika/metrika";

import chatIcon from "../../../Assets/BottomMenu/chatIcon.svg";
import profilePlaceholder from '../../../Assets/profile.svg';
import Favourites from '../../../Assets/hearts/heart-black.svg';

import styles from './UserMiniProfile.module.css';
import stylesChat from '../../layout/header/NavBar/NavBar.module.css'

const UserMiniProfile = observer(() => {
    const { user, chat } = useContext(Context);

    const history = useHistory();
    const location = useLocation();

    const totalUnreadCount = chat.unreadChatsCount;
    const isChatPage = location.pathname.startsWith(CHAT_ROUTE);

    const [showRegistrationModal, setShowRegistrationModal] = useState(false);
    const getProfileImageUrl = () => {
        if (!user.UserData || !user.UserData.id || !user.UserData.img) {
            return null;
        }

        const userId = user.UserData.id;
        const userImg = user.UserData.img;

        if (userImg === 'EMPTY') {
            return null;
        } else if (typeof userImg === 'string') {
            const constructedPath = `users/user${userId}/${userImg}`;
            const fullImageUrl = process.env.REACT_APP_API_URL + constructedPath;
            return fullImageUrl;
        }
        return null;
    };

    const profileImageUrl = getProfileImageUrl();

    const handleFavoritesClick = (e) => {
        e.stopPropagation();
        if (user.isAuth && user.UserData?.id) {
            history.push(FAVOURITES_ROUTE);
            reachGoal("history.push(FAVOURITES_ROUTE) NAVIGATION");
        } else {
            setShowRegistrationModal(true);
        }
    };

    if (!user.isAuth || !user.UserData) {
        return (
            <div className={styles.navContainer}>
                <button
                    className={styles.loginButton}
                    onClick={() => setShowRegistrationModal(true)} // <- открываем модалку
                >
                    Войти
                </button>

                <RegistrationForm show={showRegistrationModal} onHide={() => setShowRegistrationModal(false)} />
            </div>
        );
    }

    const handleChatClick = () => {
        history.push(CHAT_ROUTE);
        reachGoal("history.push(CHAT_ROUTE) NAVIGATION");
    };


    return (
        <div className={styles.navContainer}>
            <button
                className={`${stylesChat.actionButton} ${isChatPage ? stylesChat.actionButtonActive : ''} ${stylesChat.mobileHide}`}
                onClick={handleChatClick}
                title="Сообщения"
                style={{marginRight: '10px'}}
            >
                <img
                    src={chatIcon}
                    alt="Сообщения"
                    height={30}
                    className={stylesChat.actionIcon}
                    style={{padding: "1px"}}
                />
                {totalUnreadCount > 0 && (
                    <div className={stylesChat.badge}>
                        {totalUnreadCount}
                    </div>
                )}
            </button>
            <button
                className={styles.favoritesButton}
                onClick={handleFavoritesClick}
            >
                <img
                    src={Favourites}
                    alt="Избранное"
                    className={styles.favoritesIcon}
                    style={{filter: "brightness(0) invert(1)"}}
                />
            </button>

            <button
                className={styles.profileButton}
                onClick={() => {
                    history.push(`${PROFILE_ROUTE}/${user.UserData.id}`)
                    reachGoal("history.push(`${PROFILE_ROUTE} NAVIGATION`)");
                }}
            >
                <div className={styles.profileAvatarContainer}>
                    {profileImageUrl ? (
                        <img
                            src={profileImageUrl}
                            alt="Аватар"
                            className={styles.profileAvatarImg}
                        />
                    ) : (
                        <img
                            src={profilePlaceholder}
                            alt="Профиль"
                            className={styles.profileAvatarImg}
                        />
                    )}
                </div>
                <span className={styles.profileNickname}>
                    {user.UserData?.nickname || 'Пользователь'}
                </span>
            </button>
            <ModalPortal>
                <RegistrationForm show={showRegistrationModal} onHide={() => setShowRegistrationModal(false)}/>
            </ModalPortal>
        </div>
    );
});

export default UserMiniProfile;